export const RESTORE_ALME_WINDOW = "RESTORE_ALME_WINDOW";
export const INPUTBOX_SET_FOCUS = "INPUTBOX_SET_FOCUS";
export const STAGE_GET_CRM = "STAGE_GET_CRM";
export const SET_RESET_FUNCTION_FLAG = "SET_RESET_FUNCTION_FLAG";
export const SET_LAUNCH_PROACTIVE_FLAG = "SET_LAUNCH_PROACTIVE_FLAG";
export const SET_LAST_URL_LAUNCHED_FROM = "SET_LAST_URL_LAUNCHED_FROM";
export const SET_CHANNEL = "SET_CHANNEL";
export const SET_LAUNCH_POINT_NAME = "SET_LAUNCH_POINT_NAME";


// WEBPACK FOOTER //
// ./modules/window-launch/actions/actionTypes.ts